// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
	margin-bottom: 17px;
	font-family: MuseoSans-500;
	font-size: 18px;
	color: #404141;
	
}

.close-button {
	margin-top: -6px;
	padding-right: 13px;
}

form label {
  font-family: MuseoSans-300;
  font-size: 13px;
  color: #404141;
  height: 28px;
  margin-bottom: 0px;
}

form .pbxType-select {
	padding: 0;
	max-width: 28%;
}

select {
  height: 30px !important;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-right: 28px;
  -o-appearance: none;
  appearance: none;
  border-radius: 0px;
  -moz-border-radius: 0px;
  -webkit-border-radius: 0px;
  border: 1px solid #BFBFC0;
  font-family: MuseoSans-300;
  font-size: 12px;
  color: #404141;
}

select::-ms-expand {
  display: none;
}

select + span {
  float: right;
  margin-top: -27px;
  margin-right: 5px;
  pointer-events: none;
  background-color: #fff;
  padding-right: 5px;
  height: 14px;
}

select + span img {
  width: 14px;
  height: 14px;
  vertical-align: -3px;
}

hr {
  margin: 20px -18px;
}

.content {
	font-family: MuseoSans-300;
	font-size: 13px;
	color: #404141;
	letter-spacing: 0.01px;
	line-height: 30px;
	margin-bottom: 38px;
}

.description {
	line-height: 1.25;
	margin-bottom: 25px;
}

.checklist {
	padding-left: 14px;
	font-family: MuseoSans-300;
	font-size: 11px;
	color: #404141;
	letter-spacing: 0.01px;
	line-height: 25px;
}

span.info > img {
	margin-top: 3px;
}

.actions {
	position: relative;
	bottom: 20px;
	right: 10px;
	margin-top: 30px;
}

.footer-description {
	font-family: MuseoSans-300;
	font-size: 13px;
	color: #404141;
	letter-spacing: 0.01px;
	margin-bottom: 25px;
}

.plainButton {
  margin-bottom: 25px;
}

.footer-description .btn-link {
	font-family: MuseoSans-300;
	font-size: 12px;
	letter-spacing: 0.01px;
	padding: 0px;
}

.footer-description span {
	vertical-align: middle;
}

.btn-primary {
	width: 100px;
}

.beta {
    background: #F0F0F0;
    font-style: italic;
    font-weight: 100;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/pre-req/pre-req.component.css"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,0BAA0B;CAC1B,eAAe;CACf,cAAc;;AAEf;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;CACC,UAAU;CACV,cAAc;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EAGnB,mBAAmB;EAEnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,YAAY;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".title {\n\tmargin-bottom: 17px;\n\tfont-family: MuseoSans-500;\n\tfont-size: 18px;\n\tcolor: #404141;\n\t\n}\n\n.close-button {\n\tmargin-top: -6px;\n\tpadding-right: 13px;\n}\n\nform label {\n  font-family: MuseoSans-300;\n  font-size: 13px;\n  color: #404141;\n  height: 28px;\n  margin-bottom: 0px;\n}\n\nform .pbxType-select {\n\tpadding: 0;\n\tmax-width: 28%;\n}\n\nselect {\n  height: 30px !important;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  padding-right: 28px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -o-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  border-radius: 0px;\n  -moz-border-radius: 0px;\n  -webkit-border-radius: 0px;\n  border: 1px solid #BFBFC0;\n  font-family: MuseoSans-300;\n  font-size: 12px;\n  color: #404141;\n}\n\nselect::-ms-expand {\n  display: none;\n}\n\nselect + span {\n  float: right;\n  margin-top: -27px;\n  margin-right: 5px;\n  pointer-events: none;\n  background-color: #fff;\n  padding-right: 5px;\n  height: 14px;\n}\n\nselect + span img {\n  width: 14px;\n  height: 14px;\n  vertical-align: -3px;\n}\n\nhr {\n  margin: 20px -18px;\n}\n\n.content {\n\tfont-family: MuseoSans-300;\n\tfont-size: 13px;\n\tcolor: #404141;\n\tletter-spacing: 0.01px;\n\tline-height: 30px;\n\tmargin-bottom: 38px;\n}\n\n.description {\n\tline-height: 1.25;\n\tmargin-bottom: 25px;\n}\n\n.checklist {\n\tpadding-left: 14px;\n\tfont-family: MuseoSans-300;\n\tfont-size: 11px;\n\tcolor: #404141;\n\tletter-spacing: 0.01px;\n\tline-height: 25px;\n}\n\nspan.info > img {\n\tmargin-top: 3px;\n}\n\n.actions {\n\tposition: relative;\n\tbottom: 20px;\n\tright: 10px;\n\tmargin-top: 30px;\n}\n\n.footer-description {\n\tfont-family: MuseoSans-300;\n\tfont-size: 13px;\n\tcolor: #404141;\n\tletter-spacing: 0.01px;\n\tmargin-bottom: 25px;\n}\n\n.plainButton {\n  margin-bottom: 25px;\n}\n\n.footer-description .btn-link {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tletter-spacing: 0.01px;\n\tpadding: 0px;\n}\n\n.footer-description span {\n\tvertical-align: middle;\n}\n\n.btn-primary {\n\twidth: 100px;\n}\n\n.beta {\n    background: #F0F0F0;\n    font-style: italic;\n    font-weight: 100;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
